import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";
import { ShoppingBag } from "lucide-react";

export default function Store() {
  const [products, setProducts] = useState([]);
  const { add } = useCart();

  useEffect(() => { api.get("/products").then(r => setProducts(r.data)); }, []);

  const onAdd = (p) => { add(p, 1); toast.success(`${p.name} added to cart`); };

  return (
    <div data-testid="store-page">
      <section className="bg-[#0A192F] text-[#FDFBF7] relative grain overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <div className="label-eyebrow text-[#C5A059]">The Foundation Shop</div>
            <h1 className="mt-3 font-display text-5xl sm:text-6xl leading-[1.05]">Apparel & artifacts of public service.</h1>
            <p className="mt-5 text-slate-300 max-w-xl">Every purchase supports the Foundation's mentorship and convening programs for current and incoming Fellows.</p>
          </div>
          <div className="lg:col-span-5 text-right">
            <div className="font-display text-7xl text-[#C5A059]">{products.length}</div>
            <div className="label-eyebrow text-slate-300">Items in the collection</div>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map(p => (
            <article key={p.id} className="card-flat overflow-hidden group" data-testid={`product-card-${p.id}`}>
              <Link to={`/store/${p.id}`} className="block aspect-[4/5] overflow-hidden bg-slate-100">
                <img src={p.image_url} alt={p.name} className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500" />
              </Link>
              <div className="p-5">
                <div className="label-eyebrow text-slate-500">{p.category}</div>
                <div className="mt-1 flex items-center justify-between gap-3">
                  <Link to={`/store/${p.id}`} className="font-display text-xl text-[#0A192F] hover:text-[#002855]">{p.name}</Link>
                  <div className="font-mono text-sm text-[#0A192F]">${p.price.toFixed(2)}</div>
                </div>
                <p className="mt-2 text-sm text-slate-600 line-clamp-2">{p.description}</p>
                <Button onClick={() => onAdd(p)} className="mt-4 w-full bg-[#002855] hover:bg-[#0A192F] text-white rounded-md" data-testid={`add-to-cart-${p.id}`}>
                  <ShoppingBag className="w-4 h-4 mr-2" /> Add to cart
                </Button>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
